import React, { useCallback, useState } from 'react';
import { IResortReports } from 'api/resort/types';
import { BlockContent } from 'components/blocks/BlockContent';
import { Report } from 'components/resort/Report';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useAnalytics } from 'util/analytics';
import { Diagnostics } from 'util/diagnostics';
import { fetchResortReports } from 'api/resort/static';
import classNames from 'classnames';
import Loader from 'react-spinners/PuffLoader';
import theme from 'theme';
import styles from './styles.module.scss';

export const ReportsList = ({
  resortList,
  uuid,
  className,
}: {
  resortList: IResortReports,
  uuid: string,
  className?: string,
}) => {
  const { t } = useOTSTranslation('common');
  const [isLoading, toggleLoading] = useState<boolean>(false);
  const [pagesResort, addPageResorts] = useState<Array<IResortReports>>([resortList]);
  const isValidResponse = (response: IResortReports) => (
    response.pagination && response.reportsList
  );
  const a = useAnalytics();

  const loadNewReports = useCallback(async () => {
    a.viewContent({
      content: 'First Hand Reports',
    });
    toggleLoading(true);

    const newReportList: IResortReports = await fetchResortReports(uuid, pagesResort.length);

    if (!isValidResponse(newReportList)) {
      Diagnostics.error({ message: 'Server returned unknown report page type', tag: 'resort-reports' });
      return;
    }

    addPageResorts((prevPagesResort) => [...prevPagesResort, newReportList]);
    toggleLoading(false);
  }, [a, toggleLoading, addPageResorts]);

  const getLastPage = Math.ceil(pagesResort[0].pagination.count / pagesResort[0].pagination.limit);

  return (
    <div className={classNames(styles.wrapper, className)}>
      <BlockContent className={styles.box}>
        {
          pagesResort.map((item, page) => (
            <>
              {
                item.reportsList.map((resort, i) => (
                  ((page * 10 + i) % 3 === 2) ? (
                    <>
                      <Report key={resort.uuid} report={resort} className={styles.report} />
                    </>
                  ) : (
                    <Report key={resort.uuid} report={resort} className={styles.report} />
                  )
                ))
              }
            </>
          ))
        }
        {
          pagesResort.length !== getLastPage ? (
            <button
              type="button"
              className={styles.loadBtn}
              onClick={loadNewReports}
              disabled={isLoading}
            >
              {
                isLoading ? (
                  <Loader
                    color={theme.white}
                    size={32}
                  />
                ) : t('common.loadMore')
              }
            </button>
          ) : <></>
        }
      </BlockContent>
    </div>
  );
};
